export type Targeting = Partial<{
  make: string | null;
  model: string | null;
  year: number | null;
  pageType: string;
  ageType: string | null;
  cpo: boolean | null;
  inLine: number | null;
  bodyStyle: string | null;
  category: string | null;
  app: string;
  spid: string | null;
}>;

export type AdInfo = Partial<{
  // eslint-disable-next-line camelcase
  ad_unit: string;
  make: string | null;
  model: string | null;
  year: number | null;
  // eslint-disable-next-line camelcase
  page_type: string;
  // eslint-disable-next-line camelcase
  age_type: string | null;
  cpo: boolean | null;
  // eslint-disable-next-line camelcase
  in_line: number | null;
  // eslint-disable-next-line camelcase
  body_style: string | null;
  category: string | null;
  app: string;
  spid: string | null;
}>;

export async function defineSlot({
  adUnitPath,
  targeting,
  elementId,
}: {
  adUnitPath: string;
  targeting: Targeting;
  elementId: string;
}): Promise<googletag.Slot> {
  return new Promise((resolve, reject) => {
    googletag.cmd.push(() => {
      // create google slot object
      const slot = googletag.defineSlot(adUnitPath, [1, 1], elementId);

      if (!slot) {
        reject(
          new Error(
            `Could not create slot with adUnit: ${adUnitPath}, dimensions: ${'[1, 1]'}, element id: ${elementId}`
          )
        );
      }

      // add publisher ads service to the slot
      slot.addService(googletag.pubads());

      // set targeting for this slot, for autolist targeting params are
      // defined in JumpstartMapping table (e.g. make, model, year, etc)
      Object.entries(targeting).forEach(([k, v]) => {
        if (!v) {
          return;
        }

        slot.setTargeting(k, String(v));
      });

      resolve(slot);
    });
  });
}
